class LockedResource extends Error {
  constructor(message = 'The resource that is being accessed is locked.') {
    super(message)
    this.name = this.constructor.name
    this.status = 423
    Error.captureStackTrace(this, this.constructor)
  }
}

module.exports = LockedResource
